import { Dispatch } from 'redux'

// Types
import { USER } from '@/types/store/const'
import { TUser } from '@/types/data/user'

export const setUserAction: any =
  (user: TUser, jwt: any) => (dispatch: Dispatch) => {
    dispatch({
      type: USER,
      payload: {
        user,
        jwt,
      },
    })
  }
